import e from "@dialpad/dialtone-tokens/layered/themes/tokens-112-colors.css?inline";
//#region themes/112.js
var t = { brand: {
	css: e,
	name: "112"
} };
//#endregion
export { t as default };
